import {
  Box,
  Select,
  Typography,
  ListItemText,
  MenuItem,
  Checkbox,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import AddIcon from "@mui/icons-material/Add";
import { getSites } from "src/apis/complex";
import Image from "mui-image";
import downloadFileImage from "src/img/file-download.png";
import DatePicker from "react-datepicker";
import "./DataExplorerFilter.css";
import { AssetTypes } from "src/util/utility_enums";
import { ticketImpacts } from "src/util/utility_enums";
import { getAllAssets } from "src/apis/complex";
import { ticketStatuses } from "src/util/utility_enums";
import Button from "@mui/material/Button";
const DataExplorerFilterComponent = ({ filterType, setFilters }) => {
  const [complexes, setComplexes] = useState([]);
  const [sites, setSites] = useState([]);
  const [buildings, setBuildings] = useState([]);
  const [allAssets, setAllAssets] = useState([]);
  const [selectedTime, setSelectedTime] = useState(1);
  const [isOrgSelected, setIsOrgSelected] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedSite, setSelectedSite] = useState(null);
  const [selectedBuilding, setSelectedBuilding] = useState(null);
  const [aiSupervision, setAiSuperVision] = useState(false);
  const [isOnerous, setIsOnerous] = useState(false);
  const [alarmImpact, setAlarmImpact] = useState(null);
  const [assetType, setAssetType] = useState(null);
  const [assetSn, setAssetSn] = useState(null);
  const [ticketStatus, setTicketStatus] = useState(null);
  useEffect(() => {
    console.log("filter component sees : ", filterType);
  }, [filterType]);
  const handleConfirmButton = () => {
    setIsOpen(false);
  };
  // Handler to toggle organization selection
  const handleOrgClick = () => {
    if (isOrgSelected) {
      setSites([]);
      setIsOrgSelected(false);
    } else {
      setSites(complexes);
      setIsOrgSelected(true);
    }
  };

  // Handler to select a site and load its buildings
  const handleSiteClick = (id) => {
    const selectedSite = complexes.filter((site) => site.id === id);
    const siteBuildings = selectedSite.map((site) => site.buildings);
    console.log("site buildings: ", siteBuildings);
    setSites(selectedSite);
    setBuildings(siteBuildings[0]);
  };

  // Handler to close a selected site
  const handleSiteClose = (id) => {
    if (sites.length === 1) {
      setIsOrgSelected(false);
    }
    setSites((prevSites) => prevSites.filter((site) => site.id !== id));
    setBuildings([]); // rremoving bulings on site close
  };
  const resetFilters = () => {
    setSelectedSite(null);
    setSelectedBuilding(null);
    setStartDate(null);
    setEndDate(null);
    setAlarmImpact(null);
    setAssetType(null);
    setAssetSn(null);
    setIsOnerous(false);
    setTicketStatus(null);
    setAiSuperVision(false);
  };
  
  // Function to handle the click event for the "Reset All" button
  const handleResetAll = () => {
    resetFilters();
  };

  // Handler to close a selected building
  const handleBuildingClose = (id) => {
    setBuildings((prevBuildings) =>
      prevBuildings.filter((building) => building.id !== id)
    );
  };

  // Fetching site data
  const loadComplexes = async () => {
    const data = await getSites();
    setComplexes(data);
    
  };
  const loadAssets = async () => {
    const data = await getAllAssets();
    setAllAssets(data);
    
  };
  // loading site data on component mount
  useEffect(() => {
    loadComplexes();
    loadAssets();
  }, []);

  return (
    <Box
      width="225px"
      display="flex"
      flexDirection="column"
      gap="10px"
      backgroundColor="#282B30"
      color="white"
      padding="25px 15px"
      marginBottom="10px"
    >
      <Box display="flex" alignItems="center">
        <span style={{ height: "100%", display: "flex", alignItems: "center" }}>
          <KeyboardArrowLeftIcon
            fontSize="small"
            style={{ margin: "0 -6px 0 -6px" }}
          />
          <KeyboardArrowRightIcon fontSize="small" style={{ margin: 0 }} />
        </span>
        <Typography>Query</Typography>
      </Box>

      {/* Section for Grouping */}
      <Box display="flex" flexDirection="column" gap="5px">
        

        {/**Sites display */}
        <div className="verticalAlign">
          <span> Select Site: </span>
          <Select
            sx={{
              color: "white",
              height: 37,
              ".MuiOutlinedInput-notchedOutline": {
                borderColor: "white",
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "white",
              },
              ".MuiSvgIcon-root ": {
                fill: "white !important",
              },
            }}
            value={selectedSite}
            onChange={(event) => {
              setSelectedSite(event.target.value);
              handleSiteClick(event.target.value);
              console.log("id :: ", event.target.value);
            }}
          >
            {complexes &&
              complexes.map((site) => (
                <MenuItem key={site.id} value={site.id} sx={{ border: "none" }}>
                  <ListItemText primary={site.name} />
                </MenuItem>
              ))}
          </Select>
        </div>
        {/**Buildings display */}
        <div className="verticalAlign">
          {selectedSite && (
            <div>
              <span> Select Building: </span>
              <Select
                sx={{
                  color: "white",
                  height: 37,
                  ".MuiOutlinedInput-notchedOutline": {
                    borderColor: "white",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "white",
                  },
                  ".MuiSvgIcon-root ": {
                    fill: "white !important",
                  },
                }}
                value={selectedBuilding}
                onChange={(event) => {
                  setSelectedBuilding(event.target.value);
                  // handleSiteClick(event.target.value);
                  // console.log("id :: ",event.target.value)
                }}
              >
                {buildings && buildings.map((site) => (
                  <MenuItem
                    key={site.id}
                    value={site.id}
                    sx={{ border: "none" }}
                  >
                    <ListItemText primary={site.name} />
                  </MenuItem>
                ))}
              </Select>
            </div>
          )}
        </div>
        {/**startDatePicker display */}
        <div className="datepickers">
          <div>
            <div className="startDatePickerFilter">
              <span className="fromTo">From:</span>{" "}
              <DatePicker
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                dateFormat="dd/MM/yyyy"
              />
            </div>
          </div>

          {/**endDatePicker* *  display */}
          <div>
            <div className="endDatePickerFilter">
              <span className="fromTo">To:</span>{" "}
              <DatePicker
                selected={endDate}
                onChange={(date) => setEndDate(date)}
                dateFormat="dd/MM/yyyy"
              />
            </div>
          </div>
        </div>
      </Box>
      {/* Render input fields based on selected filter type */}
      {filterType === "Assets" && (
        <div className="verticalAlign">
          Asset Type:
          <Select
            sx={{
              color: "white",
              height: 37,
              ".MuiOutlinedInput-notchedOutline": {
                borderColor: "white",
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "white",
              },
              ".MuiSvgIcon-root ": {
                fill: "white !important",
              },
            }}
            value={assetType}
            onChange={(event) => {
              setAssetType(event.target.value);
              // handleSiteClick(event.target.value);
              // console.log("id :: ",event.target.value)
            }}
          >
            {AssetTypes.map((assetType) => (
              <MenuItem
                key={assetType.id}
                value={assetType.id}
                sx={{ border: "none" }}
              >
                <ListItemText primary={assetType.name} />
              </MenuItem>
            ))}
          </Select>
          Under AI Supervision
          <Checkbox
            checked={aiSupervision}
            onChange={(event) => {
              setAiSuperVision(event.target.checked);
              // handleSiteClick(event.target.value);
              // console.log("id :: ",event.target.value)
            }}
          />
        </div>
      )}

      {filterType === "Alarms" && (
        <div className="verticalAlign">
          Alarm Impact:
          <Select
            sx={{
              color: "white",
              height: 37,
              ".MuiOutlinedInput-notchedOutline": {
                borderColor: "white",
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "white",
              },
              ".MuiSvgIcon-root ": {
                fill: "white !important",
              },
            }}
            value={alarmImpact}
            onChange={(event) => {
              setAlarmImpact(event.target.value);
            }}
          >
            {ticketImpacts.map((ticketImpact) => (
              <MenuItem
                key={ticketImpact.id}
                value={ticketImpact.id}
                sx={{ border: "none" }}
              >
                <ListItemText primary={ticketImpact.name} />
              </MenuItem>
            ))}
          </Select>
    </div>
      )}


{filterType === "Tickets" && (
        <div className="verticalAlign">
          Asset:
          <Select
            sx={{
              color: "white",
              height: 37,
              ".MuiOutlinedInput-notchedOutline": {
                borderColor: "white",
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "white",
              },
              ".MuiSvgIcon-root ": {
                fill: "white !important",
              },
            }}
            value={assetSn}
            onChange={(event) => {
              setAssetSn(event.target.value);
            }}
          >
            {allAssets && allAssets.map((asset) => (
              <MenuItem
                key={asset.serialNumber}
                value={asset.serialNumber}
                sx={{ border: "none" }}
              >
                <ListItemText primary={asset.name} />
              </MenuItem>
            ))}
          </Select>
           Ticket Status
          <Select
            sx={{
              color: "white",
              height: 37,
              ".MuiOutlinedInput-notchedOutline": {
                borderColor: "white",
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "white",
              },
              ".MuiSvgIcon-root ": {
                fill: "white !important",
              },
            }}
            value={ticketStatus}
            onChange={(event) => {
              setTicketStatus(event.target.value);
            }}
          >
            {ticketStatuses.map((status) => (
              <MenuItem
                key={status.id}
                value={status.id}
                sx={{ border: "none" }}
              >
                <ListItemText primary={status.name} />
              </MenuItem>
            ))}
          </Select>
          Onerous
          <Checkbox
            checked={isOnerous}
            onChange={(event) => {
              setIsOnerous(event.target.checked);
              // handleSiteClick(event.target.value);
              // console.log("id :: ",event.target.value)
            }}
          />
        </div>
      )}


      {/* Section for Search and Download buttons */}
      <Box>
      <Button
          className="resetButton"
          variant="contained"
          onClick={handleResetAll}
        >
          Reset All
        </Button>
      </Box>
      <Box
        display="flex"
        flex={1}
        justifyContent="space-between"
      
        padding="0px 10px"
        gap="20px"
      >
        <button
          className="searchButton"
          variant="contained"
          onClick={() =>
            setFilters(
              selectedSite,
              selectedBuilding,
              startDate,
              endDate,
              alarmImpact,
              assetType,
              assetSn,
              isOnerous,
              ticketStatus
            )
          }
        >
          Search
        </button>
        <button className="downloadButton" variant="outlined">
          <Image src={downloadFileImage} style={{ height: "20px" }} />
        </button>
      </Box>
    </Box>
  );
};

export default DataExplorerFilterComponent;
